/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B090030 ロケーション移動入力
 */

import { Column } from "@material-table/core";
import { Box } from "@mui/material";
import {
  B000111Meisaibiko,
  B000130BumonNm,
  B000140ShainNmBumonCd,
  B000200ShohinNmr,
  B090030Create,
  B090030CreateRequest,
  B090030Kanosu,
  B100190Valid,
  B100190ValidRequest,
  catchRestError,
} from "clients/rest";
import {
  SDateField,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  STextField,
  SFileButton,
  SCancelButton,
  msgState,
  SEntryTab,
  SConfirmDialog,
} from "components";
import { getClientError, getClientMessage } from "messages";
import { labels } from "messages/labels";
import { B000111, B000140, B000200, B000221, B090060 } from "pages";
import { createRef, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { date, digit, mapIds } from "services";
import { meishoKbn, sokoCd } from "services/codes";
import { focusState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  pageId: string;
  idouYmd: string;
  shainCd: string;
  shainNm: string;
  bumonCd: string;
  bumonNm: string;
}>;

// 明細入力部
type MeiFields = Partial<{
  tab: boolean;
  shohinCd: string;
  shohinNmr: string;
  haraidashilocationCd: string;
  ukeirelocationCd: string;
  kanosu: string;
  idousu: string;
  meisaibikoCd: string;
  meisaibiko: string;
  meisaibikoCdBefore: string;
}>;

// 明細テーブルデータ定義
type Data = Partial<{
  gyoNo: number;
  shohinCd: string;
  shohinNmr: string;
  haraidashilocationCd: string;
  ukeirelocationCd: string;
  kanosu: number;
  idousu: number;
  meisaibikoCd: string;
  meisaibiko: string;
  meisaibikoCdBefore: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  pageId: "B090030",
  idouYmd: date(),
  shainCd: "",
  shainNm: "",
  bumonCd: "",
  bumonNm: "",
};

// 明細入力部
const defaultMeiFields: MeiFields = {
  tab: true,
  shohinCd: "",
  shohinNmr: "",
  haraidashilocationCd: "",
  ukeirelocationCd: "",
  kanosu: "",
  idousu: "",
  meisaibikoCd: "",
  meisaibiko: "",
  meisaibikoCdBefore: "",
};

// テーブルを定義する。
const columns: Column<Data>[] = [
  { field: "gyoNo", title: "行　", width: "4rem", align: "right" },
  { field: "shohinCd", title: "商品コード", width: "10rem" },
  { field: "shohinNmr", title: "商品名", width: "20rem" },
  { field: "haraidashilocationCd", title: "払出ロケーション", width: "10rem" },
  { field: "ukeirelocationCd", title: "受入ロケーション", width: "10rem" },
  {
    field: "kanosu",
    title: "可能数　",
    width: "6rem",
    align: "right",
    render: (data) => digit(data.kanosu),
  },
  {
    field: "idousu",
    title: "移動数　",
    width: "6rem",
    align: "right",
    render: (data) => digit(data.idousu),
  },
  { field: "meisaibikoCd", hidden: true },
  { field: "meisaibiko", title: "明細備考", width: "20rem" },
  { field: "meisaibikoCdBefore", hidden: true },
];

const focusId = "B090030";

export const B090030 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  const meiMethods = useForm<MeiFields>({
    mode: "onBlur",
    defaultValues: defaultMeiFields,
  });
  // テーブル管理
  const tableRef = createRef();
  const pageSize = 15;
  const [rows, setRows] = useState<Data[]>([]);
  const [rowCount, setRowCount] = useState(0);

  // フォーカス関数
  const { focus, register } = useRecoilValue(focusState(focusId));
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // テーブル行で選択されたデータ
  const [rowData, setRowData] = useState<Partial<Data>>();
  // 画面遷移
  const navigate = useNavigate();

  // 初期表示
  useEffect(() => {
    // 初期フォーカス
    focus(1);
  }, []);

  // コンポーネント
  // 担当者コード変更
  const handleChangeShainCd = () => {
    (async () => {
      // 担当者名表示処理
      await B000140ShainNmBumonCd(methods, navigate, setMsg);
      // 担当部門表示処理
      await B000130BumonNm(methods, navigate, setMsg);
    })();
  };

  // 払出ロケーションコードBlur処理
  const haraidashilocationCdCheck = () => {
    // フィールドの値取得
    const meiFields = meiMethods.getValues();
    // ロケーションコード存在チェック(存在しない場合可能数クリア)
    if (!meiFields.haraidashilocationCd) {
      meiMethods.setValue("kanosu", "");
      return;
    }
    // リクエスト作成
    const param: B100190ValidRequest = {
      // 倉庫コード901固定値
      sokoCd: sokoCd.physicalsokoCd,
      locationCd: meiFields.haraidashilocationCd!,
    };
    // API呼出し
    B100190Valid(param)
      .then(() => {
        // 可能数取得
        B090030Kanosu(meiMethods, navigate, setMsg);
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 受入ロケーションコードBlur処理
  const ukeirelocationCdCheck = () => {
    // フィールドの値取得
    const meiFields = meiMethods.getValues();
    // ロケーションコード存在チェック(存在しない場合何もしない)
    if (!meiFields.ukeirelocationCd) {
      return;
    }
    // リクエスト作成
    const param: B100190ValidRequest = {
      // 倉庫コード901固定値
      sokoCd: sokoCd.physicalsokoCd,
      locationCd: meiFields.ukeirelocationCd!,
    };
    // API呼出し
    B100190Valid(param)
      .then(() => {})
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };
  // 商品コード変更
  const handleChangeShohinCd = () => {
    // 商品名表示
    B000200ShohinNmr(meiMethods, navigate, setMsg);
    // 可能数表示
    B090030Kanosu(meiMethods, navigate, setMsg);
  };

  // 新規・編集タブクリックイベント
  const handleChangeMeiTab = () => {
    // 行選択解除
    setRowData(undefined);
    // 明細入力部の値を初期化(タブも初期化、明細登録(更新)ボタンのラベルを登録にする・明細削除ボタン非活性化)
    meiMethods.reset();
  };

  // 明細テーブル行ダブルクリックイベント
  const handleDoubleClickTableRow = (rowData: Data) => {
    // タブを編集にする・明細登録(更新)ボタンのラベル変更・明細削除ボタン活性化
    meiMethods.reset();
    meiMethods.setValue("tab", false);
    // ダブルクリックした行を選択状態にする
    setRowData(rowData);
    // 明細入力部にデータを表示する。
    meiMethods.setValue("shohinCd", rowData.shohinCd);
    meiMethods.setValue("shohinNmr", rowData.shohinNmr);
    meiMethods.setValue("haraidashilocationCd", rowData.haraidashilocationCd);
    meiMethods.setValue("ukeirelocationCd", rowData.ukeirelocationCd);
    meiMethods.setValue("kanosu", rowData.kanosu!.toString());
    meiMethods.setValue("idousu", rowData.idousu!.toString());
    meiMethods.setValue("meisaibikoCd", rowData.meisaibikoCd);
    meiMethods.setValue("meisaibiko", rowData.meisaibiko);
    meiMethods.setValue("meisaibikoCdBefore", rowData.meisaibikoCdBefore);
  };

  // 明細削除ボタンクリックイベント
  const handleClickDeteteDetailButton = () => {
    const gyoNo = rowData?.gyoNo;
    // 選択行の削除
    const newRows = rows.filter(function (source: Data) {
      return source.gyoNo !== gyoNo;
    });

    // 明細テーブルの行番号振り直し
    mapIds(newRows, "gyoNo");

    // 削除後のデータセット
    setRows(newRows);

    // 行選択の解除
    setRowData(undefined);

    // 明細入力部の初期化
    meiMethods.reset();

    // タブを新規にする
    meiMethods.setValue("tab", true);
  };

  // 明細登録(更新)ボタンクリックイベント
  const handleClickCreateDetailButton = () => {
    (async () => {
      // フィールドの値取得
      const meiFields = meiMethods.getValues();
      // 行番号
      const gyoNo: number = rowData?.gyoNo ?? rows.length + 1;

      // 入力チェック
      // 商品コード
      if (!meiFields.shohinCd) {
        setMsg(getClientError("B090030_001"));
        return;
      }
      // 払出ロケーションコード
      if (!meiFields.haraidashilocationCd) {
        setMsg(getClientError("B090030_002"));
        return;
      }
      // 受入ロケーションコード
      if (!meiFields.ukeirelocationCd) {
        setMsg(getClientError("B090030_003"));
        return;
      }
      // 移動数
      if (meiFields.idousu === "") {
        setMsg(getClientError("B090030_004"));
        return;
      }

      // 払出ロケーションコードチェックリクエスト作成
      const haraidashiparam: B100190ValidRequest = {
        // 倉庫コード901固定値
        sokoCd: sokoCd.physicalsokoCd,
        locationCd: meiFields.haraidashilocationCd!,
      };
      // 受入ロケーションコードチェックリクエスト作成
      const ukeireparam: B100190ValidRequest = {
        // 倉庫コード901固定値
        sokoCd: sokoCd.physicalsokoCd,
        locationCd: meiFields.ukeirelocationCd!,
      };
      let invalid = false;
      await B100190Valid(haraidashiparam).catch((reason) => {
        catchRestError(reason, navigate, setMsg);
        invalid = true;
      });
      await B100190Valid(ukeireparam).catch((reason) => {
        catchRestError(reason, navigate, setMsg);
        invalid = true;
      });
      if (invalid) return;

      // 払出ロケーションコードと受入ロケーションコードが同じ場合エラー
      if (meiFields.haraidashilocationCd === meiFields.ukeirelocationCd) {
        setMsg(getClientError("B090030_005"));
        return;
      }
      // 3.明細部にすでに同じ商品コードと払出ロケーションコードを持つデータがある場合エラー
      const isShohinAndHaraidashilocationDeplicate: boolean = rows
        .filter(function (source: Data) {
          return source.gyoNo !== gyoNo;
        })
        .some((row) => {
          return (
            row.shohinCd === meiFields.shohinCd &&
            row.haraidashilocationCd === meiFields.haraidashilocationCd
          );
        });
      if (isShohinAndHaraidashilocationDeplicate) {
        setMsg(getClientError("B090030_006"));
        return;
      }
      // 移動数＝＜ 0 の場合エラー
      if (Number(meiFields.idousu!) <= 0) {
        setMsg(getClientError("B090030_007"));
        return;
      }
      // 可能数＜移動数の場合エラー
      if (Number(meiFields.kanosu) < Number(meiFields.idousu)) {
        setMsg(getClientError("B090030_008"));
        return;
      }

      // タブを参照し登録処理もしくは更新処理を行う。
      if (meiMethods.getValues().tab === true) {
        // 登録
        handleDetailCreate();
      } else {
        // 更新
        handleUpdate();

        // 行選択の解除
        setRowData(undefined);
      }
    })();
  };

  // 明細登録処理
  // 明細テーブルに行追加
  const handleDetailCreate = () => {
    meiMethods.handleSubmit(
      () => {
        const gyoNo: number = rows.length + 1;
        const data: Data = handleDataMapping(gyoNo);

        // 明細を設定
        setRows([...rows, data]);
        setRowCount(gyoNo);

        // 明細入力部クリア
        meiMethods.reset();

        focus(3);
      },
      (errors) => {
        console.log(errors);
        setMsg("");
      }
    )();
  };

  // 明細更新処理
  // 明細テーブルの選択行を更新
  const handleUpdate = () => {
    // 明細に設定するデータ取得
    const gyoNo: number = rowData!.gyoNo!;
    const data: Data = handleDataMapping(gyoNo);

    // 明細を設定
    rows[gyoNo - 1] = data;
    setRows([...rows]);

    // 明細入力部クリア
    meiMethods.reset();
  };

  // 明細のデータマッピング
  const handleDataMapping = (gyoNo: number) => {
    // フォームのデータを取得する
    const meiFields = meiMethods.getValues();

    const data: Data = {
      gyoNo,
      shohinCd: meiFields.shohinCd,
      shohinNmr: meiFields.shohinNmr,
      haraidashilocationCd: meiFields.haraidashilocationCd,
      ukeirelocationCd: meiFields.ukeirelocationCd,
      kanosu: Number(meiFields.kanosu!),
      idousu: Number(meiFields.idousu!),
      meisaibikoCd: meiFields.meisaibikoCd,
      meisaibiko: meiFields.meisaibiko,
      meisaibikoCdBefore: meiFields.meisaibikoCdBefore,
    };
    return data;
  };

  // 登録ボタンクリックイベント
  const handleCreate = () => {
    const fields = methods.getValues();
    // 登録リクエスト作成
    const param: B090030CreateRequest = {
      idouYmd: fields.idouYmd!,
      shainCd: fields.shainCd!,
      bumonCd: fields.bumonCd!,
      locationIdouList: rows.map((value) => {
        return {
          shohinCd: value.shohinCd!,
          haraidashilocationCd: value.haraidashilocationCd!,
          ukeirelocationCd: value.ukeirelocationCd!,
          idosu: value.idousu!.toString(),
          meisaibiko: value.meisaibiko,
        };
      }),
    };
    // API呼出し
    B090030Create(param)
      .then(() => {
        methods.reset();
        meiMethods.reset();
        setRows([]);
        setMsg(getClientMessage("B090030_001"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // レイアウト設定
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="ロケーション移動入力"
          gridTemplateColumns="6rem 10rem 20rem 2rem 6rem 20rem"
        >
          <SLabel required>移動日</SLabel>
          <SDateField label="移動日" name="idouYmd" required {...register(1)} />
          <Box gridColumn="span 3" />
          <SFileButton
            label={labels.buttons.excelImport}
            dialog={
              <B090060
                pageId={methods.watch("pageId")}
                idouYmd={methods.watch("idouYmd")}
                shainCd={methods.watch("shainCd")}
                bumonCd={methods.watch("bumonCd")}
              />
            }
            dialogAction="close"
            align="right"
          />

          <SLabel required>担当者</SLabel>
          <STextField
            label="担当者コード"
            name="shainCd"
            size={7}
            required
            dialog={<B000140 />}
            handleSubmit={(data: any) => {
              methods.setValue("shainCd", data.shainCd);
              methods.setValue("shainNm", data.shainNm);
              methods.setValue("bumonCd", data.bumonCd);
              methods.setValue("bumonNm", data.bumonNm);
            }}
            onBlur={handleChangeShainCd}
            {...register(2)}
          />
          <STextField label="担当者名" name="shainNm" required disabled />
          <Box />
          <SLabel>担当部門</SLabel>
          <STextField label="担当部門名" name="bumonNm" disabled />
          <Box />
        </SFrame>
      </FormProvider>

      <SFrame>
        <STable
          keyName="gyoNo"
          data={rows}
          columns={columns}
          totalCount={rowCount}
          tableRef={tableRef}
          handleDoubleClick={handleDoubleClickTableRow}
          fixed={3}
          width={1250}
          height={440}
          rowSelectable={meiMethods.watch("tab")}
          pageSize={pageSize}
        />
      </SFrame>

      <FormProvider {...meiMethods}>
        <SFrame>
          <SEntryTab name="tab" handleOk={handleChangeMeiTab} />
          <SFrame gridTemplateColumns="5rem 4rem 30rem 12rem 12rem 7rem 7rem ">
            <SLabel required gridColumn="span 2">
              商品コード
            </SLabel>
            <SLabel>商品名</SLabel>
            <SLabel required>払出ロケーション</SLabel>
            <SLabel required>受入ロケーション</SLabel>
            <SLabel>可能数</SLabel>
            <SLabel required>移動数</SLabel>

            <SNumberField
              label="商品コード"
              name="shohinCd"
              code
              size={10}
              required
              gridColumn="span 2"
              dialog={<B000200 />}
              handleSubmit={(data: any) => {
                meiMethods.setValue("shohinCd", data.shohinCd);
                meiMethods.setValue("shohinNmr", data.shohinNmr);
              }}
              onBlur={handleChangeShohinCd}
              {...register(3)}
            />
            <STextField label="商品名" name="shohinNmr" size={24} disabled />
            <STextField
              label="払出ロケーションコード"
              name="haraidashilocationCd"
              size={14}
              location
              required
              onBlur={haraidashilocationCdCheck}
              dialog={<B000221 />}
              handleSubmit={(data: any) => {
                meiMethods.setValue("haraidashilocationCd", data.locationCd);
                haraidashilocationCdCheck();
              }}
              {...register(4)}
            />
            <STextField
              label="受入ロケーションコード"
              name="ukeirelocationCd"
              size={14}
              location
              required
              onBlur={ukeirelocationCdCheck}
              dialog={<B000221 />}
              handleSubmit={(data: any) => {
                meiMethods.setValue("ukeirelocationCd", data.locationCd);
              }}
              {...register(5)}
            />
            <SNumberField
              label="可能数"
              name="kanosu"
              size={6}
              disabled
              align="right"
            />
            <SNumberField
              label="移動数"
              name="idousu"
              size={6}
              required
              align="right"
              {...register(6)}
            />

            <SLabel gridColumn="span 3">明細備考</SLabel>
            <Box gridColumn="span 4" />
            <SNumberField
              label="明細備考コード"
              name="meisaibikoCd"
              code="true"
              size={3}
              dialog={<B000111 meishoKbn={meishoKbn.meisaibiko} />}
              handleSubmit={(data: any) => {
                meiMethods.setValue("meisaibikoCd", data.meishoCd);
                meiMethods.setValue("meisaibiko", data.meishoNm1);
                meiMethods.setValue("meisaibikoCdBefore", data.meishoCd);
              }}
              onBlur={() => B000111Meisaibiko(meiMethods, navigate, setMsg)}
              {...register(7)}
            />
            <STextField
              label="明細備考"
              name="meisaibiko"
              size={30}
              gridColumn="span 2"
              {...register(8)}
            />
            <Box gridColumn="span 4" />

            <SCancelButton
              label={labels.buttons.deleteDetail}
              disabled={meiMethods.getValues().tab}
              onClick={handleClickDeteteDetailButton}
              align="left"
              {...register(10)}
            />
            <Box gridColumn="span 5" />
            {meiMethods.getValues().tab === true ? (
              <SNormalButton
                label={labels.buttons.createDetail}
                align="right"
                {...register(9)}
                onClick={handleClickCreateDetailButton}
              />
            ) : (
              <SNormalButton
                label={labels.buttons.updateDetail}
                align="right"
                {...register(9)}
                onClick={handleClickCreateDetailButton}
              />
            )}
          </SFrame>
          <SFrame>
            <SNormalButton
              label={labels.buttons.create}
              align="right"
              {...register(11)}
              dialog={
                <SConfirmDialog
                  title="ロケーション移動入力"
                  msg="登録します。よろしいですか？"
                />
              }
              dialogAction="confirm"
              handleSubmit={handleCreate}
            />
          </SFrame>
        </SFrame>
      </FormProvider>
    </>
  );
};
